import { flex } from "@styled-system/patterns";

export const wrapperClass = flex({
	flexWrap: "wrap",
	alignItems: "center",
	gap: "8",
});
